import {
	PropsWithChildren,
	ReactElement,
} from "react";
import { setTrackingId } from "client/Misc/utils";

export type ReorderableListItemBaseProps = {
	trackingId: string | undefined;
};

export const ReorderableListItemBase = (
	props: PropsWithChildren<ReorderableListItemBaseProps>
): ReactElement => {
	const {
		children,
		trackingId
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
		>
			{children}
		</div>
	);
};

ReorderableListItemBase.displayName = "ReorderableList.ItemBase";